import {deburr} from 'lodash'

// Vuetify's default filters are accent-sensitive, so "Andre" would not find "André".
// deburr only knows precomposed Latin-1/Extended-A letters, so NFD first splits off the marks of ễ, ț and the like.
// Stored names carry stray spaces and write apostrophes as ´, so those are evened out too.
const normalize = (value: string): string =>
    deburr(value.normalize('NFD')).toLocaleLowerCase()
        .replace(/['´`’ʼ‘]/g, '')
        .replace(/[\s-]+/g, ' ')
        .trim()

// Vuetify calls a filter once per item or cell with the same search, so normalize it only when it changes.
let lastSearch: string | null = null
let lastNormalizedSearch = ''

const normalizeSearch = (search: string): string => {
    if (search !== lastSearch) {
        lastSearch = search
        lastNormalizedSearch = normalize(search)
    }

    return lastNormalizedSearch
}

const matches = (value: string, search: string): boolean =>
    normalize(value).includes(normalizeSearch(search))

// For the `filter` prop of v-autocomplete.
export const accentInsensitiveItemFilter = (item: any, queryText: string, itemText: string): boolean =>
    matches(itemText, queryText)

// For the `custom-filter` prop of v-data-table, which passes raw cell values, nulls and booleans included.
export const accentInsensitiveTableFilter = (value: any, search: string | null): boolean =>
    value != null && search != null && typeof value !== 'boolean'
    && matches(value.toString(), search)
